import { MenuItem, Select, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useEffect } from "react";

const VenueDataBlock = ({
  item,
  index,
  languages,
  decks,
  locationLabels,
  sideLabels,
  onChange,
  onDelete,
  showDelete = true,
}) => {

  useEffect(() => {
    // only auto-fill once
    if (!item._initialized) {
      if (!item.deckNumber && decks?.length > 0) {
        onChange(index, "deckNumber", decks[0]);
      }

      languages.forEach((lang) => {
        const locKey = `location${lang.keySuffix}`;
        const locOptions = Object.keys(locationLabels[lang.keySuffix] || {});
        if (!item[locKey] && locOptions.length > 0) {
          onChange(index, locKey, locOptions[0]);
        }

        const sideKey = `side${lang.keySuffix}`;
        const sideOptions = Object.keys(sideLabels[lang.keySuffix] || {});
        if (!item[sideKey] && sideOptions.length > 0) {
          onChange(index, sideKey, sideOptions[0]);
        }
      });

      // mark initialized
      onChange(index, "_initialized", true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once

  return (
    <div
      className="row mb-3 p-3"
      style={{
        border: "3px solid #ddd",
        borderRadius: "8px",
        position: "relative",
      }}
    >
      {showDelete && index !== 0 && (
        <IconButton
          style={{ position: "absolute", top: -10, right: -10, color: "grey" }}
          size="medium"
          onClick={() => onDelete(index)}
        >
          <DeleteIcon fontSize="large" />
        </IconButton>
      )}

      {languages.map((lang) => (
        <div
          key={`deck-${lang.keySuffix}`}
          className="col-lg-4 col-md-12 col-sm-12 col-12"
        >
          <div className="fieldrow">
            <label className="f_label">{`Deck Number ${lang.labelSuffix}`}</label>
            <Select
              style={{ width: "100%", height: "45px" }}
              value={item.deckNumber ?? "NA"} // show NA if null or undefined
              onChange={(e) => {
                const val = e.target.value === "NA" ? null : e.target.value;
                onChange(index, "deckNumber", val);
              }}
            >
              {decks?.map((deck) => (
                <MenuItem key={deck ?? "NA"} value={deck ?? "NA"}>
                  {deck === null ? "NA" : `${lang.deck} ${deck}`}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      ))}

      {languages.map((lang) => (
        <div
          key={`location-${lang.keySuffix}`}
          className="col-lg-4 col-md-12 col-sm-12 col-12"
        >
          <div className="fieldrow">
            <label className="f_label">{`Deck Location ${lang.labelSuffix}`}</label>
            <Select
              style={{ width: "100%", height: "45px" }}
              value={item[`location${lang.keySuffix}`] ?? "NA"}
              onChange={(e) => {
                const val = e.target.value === "NA" ? "NA" : e.target.value;
                languages.forEach((l) =>
                  onChange(index, `location${l.keySuffix}`, val)
                );
              }}
            >
              {(() => {
                const locOptions = Object.entries(
                  locationLabels[lang.keySuffix] || {}
                );
                const currentValue = item[`location${lang.keySuffix}`];
                const hasCurrent = locOptions.some(
                  ([key]) => key === currentValue
                );

                if (currentValue && !hasCurrent) {
                  locOptions.unshift([currentValue, currentValue]);
                }

                return locOptions.map(([key, label]) => (
                  <MenuItem key={key} value={key}>
                    {key === "NA" ? "NA" : label}
                  </MenuItem>
                ));
              })()}
            </Select>

          </div>
        </div>
      ))}

      {languages.map((lang) => (
        <div
          key={`side-${lang.keySuffix}`}
          className="col-lg-4 col-md-12 col-sm-12 col-12"
        >
          <div className="fieldrow">
            <label className="f_label">{`Deck Side ${lang.labelSuffix}`}</label>
            <Select
              style={{ width: "100%", height: "45px", fontStyle: "normal" }}
              value={item[`side${lang.keySuffix}`] ?? "NA"}
              onChange={(e) => {
                languages.forEach((l) =>
                  onChange(index, `side${l.keySuffix}`, e.target.value)
                );
              }}
            >
              {(() => {
                const sideOptions = Object.entries(
                  sideLabels[lang.keySuffix] || {}
                );
                const currentValue = item[`side${lang.keySuffix}`];
                const hasCurrent = sideOptions.some(
                  ([key]) => key === currentValue
                );

                if (currentValue && !hasCurrent) {
                  sideOptions.unshift([currentValue, currentValue]);
                }

                return sideOptions.map(([key, label]) => (
                  <MenuItem key={key} value={key}>
                    {key === "NA" ? "NA" : label}
                  </MenuItem>
                ));
              })()}
            </Select>

          </div>
        </div>
      ))}

      <div className="col-lg-4 col-md-12 col-sm-12 col-12">
        <div className="fieldrow">
          <label className="f_label">Enter Extension Number</label>
          <input
            className="f_input"
            type="text"
            value={item.extensionNumber || ""}
            onChange={(e) => onChange(index, "extensionNumber", e.target.value)}
          />
        </div>
      </div>

      <div className="col-lg-8 col-md-12 col-sm-12 col-12">
        <div className="fieldrow">
          <label className="f_label">Refined Tags</label>
          <input
            className="f_input"
            type="text"
            value={item.refinedTags || ""}
            onChange={(e) => onChange(index, "refinedTags", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default VenueDataBlock;
